import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

export const useEnrollmentComments = () => {
  const searchParams = useSearchParams();

  const commentId = searchParams.get('commentId');

  const [showComments, setShowComments] = useState(Boolean(commentId));

  return {
    showComments,
    setShowComments,
    selectedCommentId: commentId,
  };
};
